import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PanelList } from '../../shared/models/panel-list';
import { HardCopyActivityService } from '../services/hard-copy-activity.service';
import { LocationsService } from '../../shared/services/locations.service';
import { SpeedDialMenu } from '../../../app/shared/models/speed-dial-menu';
import { HardCopyConstants } from '../hard-copy.constants';
import { AssignmentGroupSharedDataService } from '../../../app/shared/services/assignment-group-shared-data.service';
import { LabelConstants } from '../../../app/shared/constants/label-constants';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { CommonService } from '../../../app/shared/services/common.service';


@Component({
  selector: 'app-hard-copy-management',
  templateUrl: './hard-copy-management.component.html',
  styleUrls: ['./hard-copy-management.component.scss']
})
export class HardCopyManagementComponent implements OnInit, OnDestroy {
  @Input() documentNumber!: string;
  @Input() documentVersion!: string;
  @Input() documentStatus !: number;
  @Input() addHardCopyButton !: boolean;  
  @Input() fileId!:any;
  @Input() fileName!:any;
  isHardCopyActivitySliderOpen:boolean = false;
  showRemovedCopiesChange = false;
  hardCopydata:PanelList={
    lists:[],
    filters:[],
    sort:[]
  };
  lists : any=[]
  ispanelListDataAvailable:boolean=true;
  displayConfirmationDialog:boolean=false;
  displayRemoveCopiesDialog:boolean=false;
  completeHardcopyActivityId:any="";
  maxDefaultCopies:any;
  isRemoveActivity:any;
  dataActivityId:any;
  isDeleteModalVisible:boolean=false;
  isConfirmationModalVisible:boolean=false;
  speedDialOptions!: SpeedDialMenu[];
  showHardCopyActivityModal:boolean = false;
  hardCopyActivityIdForAudit:string='';
  showLoader : boolean = false;
  
  // Subscriptions to prevent memory leaks
  private deleteSubscription?: Subscription;
  private completedSubscription?: Subscription;
  private createdOrEditedSubscription?: Subscription;

  constructor(private hardCopyActivityService: HardCopyActivityService,
     private assignmentGroupSharedDataService:AssignmentGroupSharedDataService,
     private commonService: CommonService) { 

  }

  ngOnInit(): void {
    this.loadHardcopyActivityData();
      this.hardCopydata.lists.title="Panel List";
      
      // Store subscriptions to unsubscribe later
      this.deleteSubscription = this.hardCopyActivityService.OnHardcopyActivityDelete()
      .subscribe((isUpdated:boolean) => this.HardcopyActivityDeleted(isUpdated));
      
      this.completedSubscription = this.hardCopyActivityService.OnHardcopyActivityComplted()
      .subscribe((isUpdated:boolean) => this.HardcopyActivityCompleted(isUpdated));
      
      this.createdOrEditedSubscription = this.hardCopyActivityService.OnHardcopyActivityCreatedOrEdited()
      .subscribe((isUpdated:boolean) => this.HardcopyActivityCreatedOrEdited(isUpdated));
  }

  HardcopyActivityDeleted(isUpdated: boolean) {
    if (isUpdated) {
      setTimeout(() => {    
        this.loadHardcopyActivityData();
      }, 2000);
      
    }
  }

  HardcopyActivityCompleted(isUpdated: boolean) {
    if (isUpdated) {
      setTimeout(() => {
        this.loadHardcopyActivityData();
      }, 1000);
      
    }
  }

  HardcopyActivityCreatedOrEdited(isUpdated: boolean) {
    if (isUpdated) {
      setTimeout(() => {
        this.loadHardcopyActivityData();
      }, 2000);
      
    }
  }

  openHardCopyActivitySlider(){
    this.dataActivityId = '';
    this.isHardCopyActivitySliderOpen = !this.isHardCopyActivitySliderOpen;
  }

  loadHardcopyActivityData(){
    this.showLoader = true;
    this.getHardCopiesForDocument(); 
  }
handleDeleteModal(event:any)
{
  this.isDeleteModalVisible=false;
}
handleConfirmation(event:any)
{
  this.isConfirmationModalVisible=false;
}

  editHardCopyActivitySlider(activityId:any,activityStatus:any)
  {
    this.isHardCopyActivitySliderOpen = !this.isHardCopyActivitySliderOpen;
    this.dataActivityId=activityId;
    if(activityStatus=='Done')
    {
      this.showRemovedCopiesChange=true;
    }
    else{
      this.showRemovedCopiesChange=false;
    }
  }

  closeSliderOnConfiramtion(closeSlider: boolean) {
    this.dataActivityId='';
      this.isHardCopyActivitySliderOpen = !closeSlider;
  }
  onCopiesChanges(keyEvent : any){
    if(Number(keyEvent.target.value) < 1){
      keyEvent.target.value = 1;
    };
  }

  openConfirmationModal(hardcopyActivityId:any,hardcopyActivityStatus:string,hardcopyActivityValue:string,copies:any):void{
    this.completeHardcopyActivityId = hardcopyActivityId;
    this.isConfirmationModalVisible=true;
    this.maxDefaultCopies=copies;
    if(hardcopyActivityStatus =='Pending' && hardcopyActivityValue =='Remove')
    {
      this.isRemoveActivity=true;
    }
    else
    {
      this.isRemoveActivity=false;
    }
    this.displayConfirmationDialog=true;
  }

  openRemoveHardCopiesModal(hardcopyActivityId:any):void{
    this.isDeleteModalVisible=true;
  this.displayRemoveCopiesDialog=true;
  this.completeHardcopyActivityId = hardcopyActivityId;
  }
    
    
    addSorting():void{
    this.hardCopydata.sort = [];
    this.hardCopydata.enableSort=true;
    this.hardCopydata.sort?.push(
      {
        sortFieldDisplayName:"Activity",
        sortFieldName:"activity"
      }
    );
    this.hardCopydata.sort?.push(
      {
        sortFieldDisplayName:"Status",
        sortFieldName:"status"
      }
    );
    this.hardCopydata.sort?.push(
      {
        sortFieldDisplayName:"Assigned Users",
        sortFieldName:"assignedUserList"
      }
    );
    this.hardCopydata.sort?.push(
      {
        sortFieldDisplayName:"Copies",
        sortFieldName:"copies"
      }
    );
    this.hardCopydata.sort?.push(
      {
        sortFieldDisplayName:"Removed Copies",
        sortFieldName:"removedCopies"
      }
    );
    this.hardCopydata.sort?.push(
      {
            sortFieldDisplayName:"eQMS Scope",
            sortFieldName:"eQMSScopeName"
      }
    );
    this.hardCopydata.sort?.push(
      {
        sortFieldDisplayName:"Hardcopy Storage Location",
        sortFieldName:"hardcopyStorageLocation"
      }
    );
    this.hardCopydata.sort?.push(
      {
        sortFieldDisplayName:"Notes",
        sortFieldName:"notes"
      }
    );
  }
  addFilters():void{
    this.hardCopydata.filters = [];
    this.hardCopydata.enableFilter=true;
    this.hardCopydata.filters?.push(    
      {
        filterDisplayName:"Status",
        filterFieldName:"status",
      });
      this.hardCopydata.filters?.push(    
        {
          filterDisplayName:"Assigned User",
          filterFieldName:"assignedUserList",
        });
        this.hardCopydata.filters?.push(    
          {
            filterDisplayName:"eQMS Scope",
            filterFieldName:"eQMSScopeName",
          }); 
          this.hardCopydata.filters?.push(    
            {
              filterDisplayName:"Hardcopy Storage Location",
              filterFieldName:"hardcopyStorageLocation",
            }); 
  }

  private getHardCopiesForDocument() {
    // Show loader at the start
    this.showLoader = true;
  
    // Fetching hard copy activities
    this.hardCopyActivityService.getHardCopyActivities(this.documentNumber, Number(this.documentVersion))
      .subscribe(
        (serviceData) => {
          // Check if serviceData is null or undefined
          if (serviceData == null) {
            console.error('Service data is null or undefined');
            this.showLoader = false;
            return;
          }
  
          // Check if serviceData contains any error 
          if (serviceData.error || !Array.isArray(serviceData)) {
            console.error('Invalid service data received:', serviceData);
            this.showLoader = false;
            return;
          }
  
          // Updating the lists with data fetched from the service
          this.hardCopydata.lists = this.assignmentGroupSharedDataService.getPanelListDataWithProperty(serviceData, LabelConstants.MyHardCopyDefaultUserLable);
          this.ispanelListDataAvailable = !this.commonService.IsListEmpty(this.hardCopydata.lists);
  
          // Call to update eQMS scope data
          this.addFilters();
          this.addSorting();
  
          // Triggering these actions only after successful execution of all operations
          this.hardCopyActivityService.hardcopyActivityCreatedOrEdited.next(false);
          this.hardCopyActivityService.hardcopyActivityCompleted.next(false);
          this.hardCopyActivityService.hardcopyActivityDeleted.next(false);
  
          // Hide loader after completing everything
          this.showLoader = false;
        },
        (error) => {
          // Log any errors from the observable
          console.error('Error fetching hard copy activities or eQMS scope data:', error);
          this.hardCopydata.lists=[];
          this.showLoader = false;
        }
      );
  }
    

  setData(hcData:any):any
  {
    this.speedDialOptions=[];
    if(hcData?.hardCopyAuthorizationFlags.deleteHardCopyButton)
    {
      this.speedDialOptions.push(
        {
          tooltipOptions: {
            tooltipLabel: "Delete",
            tooltipPosition: "left",
          },
          icon: 'pi pi-trash',
          command: () => {
            this.openRemoveHardCopiesModal(hcData.activityId);
          }
        }
      );
    }
    this.speedDialOptions.push(
      {
        tooltipOptions: {
          tooltipLabel: "Audit",
          tooltipPosition: "left",
        },
        icon: 'pi pi-history',
        command: () => {
          this.openHardCopyActivityAuditModal(hcData.activityId);
        }
      }
    );
    if (hcData?.hardCopyAuthorizationFlags.editHardCopyButton) {
      this.speedDialOptions.push(
        {
          tooltipOptions: {
            tooltipLabel: "Edit",
            tooltipPosition: "left",
          },
          icon: 'pi pi-pencil',
          command: () => {
            this.editHardCopyActivitySlider(hcData.activityId, hcData.status);
          }
        }
      );
    }
    if(hcData?.status!== HardCopyConstants.HardCopyActivity_Activity_Status_Done && hcData?.hardCopyAuthorizationFlags.completeHardCopyButton){
      this.speedDialOptions.push(
        {
        tooltipOptions: {
          tooltipLabel: "Complete",
          tooltipPosition: "left",
        },
        icon: 'pi pi-check',
        command: () => {
          this.openConfirmationModal(hcData.activityId, hcData.status, hcData.activity, hcData.copies);
        }
      }
      )
    }

    if(hcData?.status!== HardCopyConstants.HardCopyActivity_ActivityStatus_Pending && hcData?.hardCopyAuthorizationFlags.downloadDocumentButton)
    {
      this.speedDialOptions.push(
        {
        tooltipOptions: {
          tooltipLabel: "Print",
          tooltipPosition: "left",
        },
        icon: 'pi pi-print',
        command: () => {
          this.hardCopyActivityService.downloadSourceFile(this.fileId,this.fileName,this.documentStatus);
        }
      }
      )

    }
    return this.speedDialOptions;
  }

  openHardCopyActivityAuditModal = (activityId:string) => {
    this.hardCopyActivityIdForAudit = activityId;
    this.showHardCopyActivityModal = true;
  }
  closeHardCopyActivityAuditModal = (isModalOpen: boolean) => {
    this.hardCopyActivityIdForAudit = '';
    this.showHardCopyActivityModal = isModalOpen;
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions to prevent memory leaks
    if (this.deleteSubscription) {
      this.deleteSubscription.unsubscribe();
    }
    if (this.completedSubscription) {
      this.completedSubscription.unsubscribe();
    }
    if (this.createdOrEditedSubscription) {
      this.createdOrEditedSubscription.unsubscribe();
    }
  }
}
